var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alerts.length > 0)?_c('div',{staticClass:"alerts-block"},_vm._l((_vm.alerts),function(alert){return _c('div',{key:alert.id},[_c('Alert',{attrs:{"id":alert.id,"message":alert.message,"isGlobal":true,"color":alert.color,"duration":alert.duration},on:{"closed":function($event){return _vm.removeAlert(alert)}}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }